/* eslint import/prefer-default-export: 0 */
import partition from 'lodash/partition';

const defaultIteratee = x => x;

export function combineLists(list1, list2) {
  if (list2.length === 0) {
    return list1.map(x => [x, undefined]);
  }
  if (list1.length === 0) {
    return list2.map(x => [undefined, x]);
  }

  const [item1, ...rest1] = list1;
  const [item2, ...rest2] = list2;

  return [[item1, item2], ...combineLists(rest1, rest2)];
}

export function pairLists(list1, list2, iteratee = defaultIteratee) {
  const [common1, uncommon1] = partition(list1, x => {
    const index = list2.findIndex(y => iteratee(y) === iteratee(x));
    return index >= 0;
  });
  const [common2, uncommon2] = partition(list2, x => {
    const index = list1.findIndex(y => iteratee(y) === iteratee(x));
    return index >= 0;
  });
  common2.sort((a, b) => {
    const indexA = common1.findIndex(x => iteratee(x) === iteratee(a));
    const indexB = common1.findIndex(x => iteratee(x) === iteratee(b));
    return indexA - indexB;
  });

  return [...combineLists(common1, common2), ...combineLists(uncommon1, uncommon2)];
}
